import React from 'react';

const ExpanderExpandedIcon: React.FC = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
		role="presentation"
	>
		<path d="M18 9L12 15L6 9" />
	</svg>
);

export default ExpanderExpandedIcon;
